import { createPortal } from 'react-dom';

// Renders children into document.body so position:fixed overlays escape any
// transformed ancestor. Page wrappers use .fade-in, whose animation-fill-mode:both
// retains transform: translateY(0) after the animation ends — a non-none transform
// makes that element the containing block for fixed descendants, so a modal nested
// inside it would size/position against the page div instead of the viewport.
const Portal = ({ children }) => createPortal(children, document.body);

export default Portal;
